import { create } from 'zustand';
import type { Group, CreateGroupRequest, UpdateGroupRequest } from '@daynote/shared-types';
import { getDataSource } from '../data';

interface GroupsState {
  groups: Group[];
  loaded: boolean;
  load: () => Promise<void>;
  create: (data: CreateGroupRequest) => Promise<Group>;
  update: (id: string, data: UpdateGroupRequest) => Promise<void>;
  remove: (id: string) => Promise<void>;
  /** 按简写查找（大小写不敏感），用于 [简写] 快捷输入识别 */
  findByAbbr: (abbr: string) => Group | undefined;
}

export const useGroupsStore = create<GroupsState>((set, get) => ({
  groups: [],
  loaded: false,

  load: async () => {
    const { groups } = await getDataSource().listGroups();
    set({ groups, loaded: true });
  },

  create: async (data) => {
    const group = await getDataSource().createGroup(data);
    set((s) => ({ groups: [...s.groups, group] }));
    return group;
  },

  update: async (id, data) => {
    const updated = await getDataSource().updateGroup(id, data);
    set((s) => ({ groups: s.groups.map((g) => (g.id === id ? updated : g)) }));
  },

  remove: async (id) => {
    await getDataSource().removeGroup(id);
    set((s) => ({ groups: s.groups.filter((g) => g.id !== id) }));
  },

  findByAbbr: (abbr) =>
    get().groups.find((g) => g.abbr.toLowerCase() === abbr.toLowerCase()),
}));
